<template>
    <div class="panel-setting-wrapper">
        <i class="fal fa-cog"></i>
    </div>
</template>
<style lang="less">
    .panel-setting-wrapper{
        width: 130px;
        height: 80px;
        margin-left: -10px;
        margin-top: -10px;
        padding-top: 25px;
        background: white;
        position: absolute;
        text-align: center;
        i{
            font-size:20px;
        }
        th &{
            vertical-align: middle;
        }
    }
</style>
<script>
export default {
    props: ['column']
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/table/header/PanelPropertyActionsHeader.vue